/**
 * TanStack Router: /clients/:clientCode/dashboard
 *
 * Client Dashboard Page - Financial Performance Metrics
 * Displays comprehensive client performance data including actual vs PROA comparison.
 *
 * Epic: MONU-FINANCIAL-SETTING-epic-003
 * Story: MONU-FINANCIAL-SETTING-story-3.001
 *
 * @see docs/architecture/monumenta-financial-settings-architecture.md
 * @see docs/stories/MONU-FINANCIAL-SETTING-story-3.001.md
 */

import { createFileRoute } from '@tanstack/react-router'
import ClientDashboard from '@/app/clients/client-dashboard'

/**
 * Route: /clients/:clientCode/dashboard
 * Layout: _auth (authenticated)
 * Component: ClientDashboard
 *
 * Access Control: Controlled by Sidebar visibility (admin, diretor, ceo roles)
 */
export const Route = createFileRoute('/_auth/clients/$clientCode/dashboard')({
  component: ClientDashboard,
})
